module.exports = __webpack_public_path__ + "img/snowAccumulation.29fd195a.png";